import { colorSystem, Tooltip } from '@luminovo/design-system';
import { InfoIcon } from 'lucide-react';
import type { JSX } from 'react';

export interface HelpIconProps {
    tooltipTitle: string;
    size?: number;
    color?: string;
}

export const HelpIcon = ({ tooltipTitle, size = 20, color = colorSystem.neutral[6] }: HelpIconProps): JSX.Element => {
    return (
        <Tooltip title={tooltipTitle}>
            <InfoIcon size={size} color={color} aria-hidden />
        </Tooltip>
    );
};
